import SummaryHeaderComponent from "./SummaryHeader.Component";

export default SummaryHeaderComponent;
